/** @jsx jsx */
import React from 'react'
import { jsx, Box, Flex } from 'theme-ui'
import _ from 'lodash'
import { animated } from 'react-spring'
import { IPositionCoords, IPositionAnimationCoords } from '../page/GameDetails/positionProps'

export const Positioned: React.SFC<{
  width: number
  height?: number
  coords: IPositionCoords
}> = ({ width, height, coords: position, ...props }) => (
  <Box
    sx={{
      width,
      height: height || width,
      position: 'absolute',
      top: position.top + (height || width) * -0.5,
      left: position.left + width * -0.5,
    }}
    {...props}
  >
    {props.children}
  </Box>
)

export const AnimatedPositioned: React.SFC<{
  width: number
  height?: number
  coords: IPositionAnimationCoords
  style?: React.CSSProperties
}> = ({ width, height, coords, style = {}, ...props }) => {
  return (
    <animated.div
      style={{
        position: 'absolute',
        zIndex: 1,
        width,
        height: height || width,
        top: coords.top.interpolate((o) => (o as number) + (height || width) * -0.5),
        left: coords.left.interpolate((o) => (o as number) + width * -0.5),
        ...style,
      }}
      {...props}
    >
      {props.children}
    </animated.div>
  )
}
